import React from "react";
import { SlDiamond } from "react-icons/sl";
import { useEffect,useState } from "react";
import { motion } from "framer-motion";

export default function DutyCardList({ items }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);



  return (
    <div className="w-full">

    {

        isMobile ?
        <div className="w-full  overflow-x-auto relative">
            <motion.div
                className="flex gap-4 snap-mandatory"
                animate={{ x: ["100%", "50%"] }} 
                transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
            >
                {items.concat(items).map((item, idx) => (
                <div key={idx} className="flex-shrink-0 w-[280px] lg:w-[320px] snap-start">
                    <Card {...item} />
                </div>
                ))}
            </motion.div>
        </div>
        :
            <div className="hidden md:flex flex-wrap justify-center gap-10 lg:px-20 px-3">
                {items.map((item, idx) => (
                <Card key={idx} {...item} />
                ))}
        </div>


    }
   
    </div>
  );
}

function Card({ icon, title, desc }) {
  return (

    <div className="rounded-[20px] hover:scale-105 transition-transform duration-300 text-special 
      lg:h-[240px] lg:w-[320px] w-[280px] h-[170px] bg-white shadow-md flex flex-col justify-between items-center px-6 lg:px-10 py-6 lg:py-10 border border-gray-200">
      
      {icon ? React.cloneElement(icon, { size: 30, className: "text-special" }) : <SlDiamond size={25} className='text-special' />}
      <p className="text-center my-3 text-[16px] lg:text-xl font-bold whitespace-normal">
        {title}
      </p>
      <div className="w-full mt-2">
        <p className="text-[13px] lg:text-sm text-center font-light whitespace-normal leading-relaxed">
          {desc}
        </p>
      </div>
    </div>
  );
}
